/* 興味関心チェック */
import * as React from 'react';
import KanaList from '../containers/KanaList';
import { kirokuUserListHeader, UserSelectBody, Type } from './UserListField';

import 'react-bootstrap';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/user_select.css';
import '../css/locomo.css';
import '../css/calendar.css';
import '../css/print.css';
import * as PropTypes from 'prop-types';
import * as Header from '../constants/Header';

interface UserInterestCheckProps extends React.Props<{}> {
  moffAPI: any;
  appUser: any;
  interestCheck?: any;
  moffAPIActions: any;
  appUserActions: any;
  interestCheckActions: any;
  headerActions?: any;
}

class UserInterestCheck extends React.Component<UserInterestCheckProps, {}> {
  static propTypes = {
    moffAPI: PropTypes.any.isRequired,
    moffAPIActions: PropTypes.any.isRequired,
    appUserActions: PropTypes.any.isRequired,
    interestCheck: PropTypes.any.isRequired,
    interestCheckActions: PropTypes.any.isRequired,
  };

  // 一覧から選択したユーザ.
  selectedUserId = '';

  componentWillMount() {
    document.title = '興味関心チェック';

    this.props.headerActions.setPage(Header.USER_INTEREST_CHECK);

    // Action
    this.props.moffAPIActions.getUsers();
  }

  // 親側の実装.
  static get childContextTypes() {
    return {
      callbackParent: PropTypes.func,
    };
  }

  /**
   * 各子のコンポーネントから呼ばれるcontext管理.
   *
   * @returns
   * @memberof UserInterestCheck
   */
  getChildContext() {
    const callback: Function = (userId: string) => {
      // 登録の確認Action.
      this.props.appUserActions.getAppUser(Type.InterestCheck, userId);
      this.selectedUserId = userId;
    };

    return {
      callbackParent: callback,
    };
  }

  /**
   *
   *
   * @returns
   * @memberof UserInterestCheck
   */
  render () {
    if (this.props.appUser.Loaded && this.props.appUser.result) {
      // 興味関心チェック.
      window.location.href = `/interest_check_print/${this.props.appUser.result.total}/` +
        `${this.props.appUser.result.uniqueId}/${this.selectedUserId}`;
    }

    return (
      <div>
        <KanaList />
        {
          (() => {
            // 通常のAPI.
            if (this.props.moffAPI.Loaded
              // アプリユーザのAPI.
              && (this.props.appUser.Loaded === false && this.props.appUser.Loading === false) ||
              this.props.appUser.Loaded) {
              return;
            }

            // ローディング中
            return <div><div id="loader" /><div id="loader_back" /></div>;
          })()
        }

        <div id="userlist">
          <table className="tblStyle01">
            <thead>
              <tr>
                {kirokuUserListHeader}
              </tr>
            </thead>
            <tbody>
            {(this.props.moffAPI.Loaded) ? 
              // ロードしたUserを表示.
              <UserSelectBody
                type={Type.InterestCheck}
                users={this.props.moffAPI.result}
                interestCheck={this.props.interestCheck}
                interestCheckActions={this.props.interestCheckActions}
              /> 
             :
              // ロード中.
              (null)
            }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default UserInterestCheck;



// WEBPACK FOOTER //
// ./src/components/UserInterestCheck.tsx